module.exports = __webpack_public_path__ + "./images/Precios.d2595c879e182ccb5890e73c7eb5dd86.png";


//////////////////
// WEBPACK FOOTER
// ./websources/public/images/Precios.png
// module id = ./websources/public/images/Precios.png
// module chunks = 0